import { TextValue } from '../_general';

export enum TerritoryEnum {
    NONE = 0,
    ASIA = 1,
    AUSTRALIA,
    BOSTON,
    CHICAGO,
    EUROPE,
    INDUSTRY_OTHER,
    JACKSON_LABS,
    LOS_ANGELES,
    NEW_YORK,
    NORTHEAST,
    SAN_DIEGO,
    SOUTHEAST,
    TACONIC,
    WEST_COAST,
}

export const territoryText: { [key in TerritoryEnum]: string } = {
    [TerritoryEnum.NONE]: '',
    [TerritoryEnum.ASIA]: 'Asia',
    [TerritoryEnum.AUSTRALIA]: 'Australia',
    [TerritoryEnum.BOSTON]: 'Boston',
    [TerritoryEnum.CHICAGO]: 'Chicago',
    [TerritoryEnum.EUROPE]: 'Europe',
    [TerritoryEnum.INDUSTRY_OTHER]: 'Industry/Other',
    [TerritoryEnum.JACKSON_LABS]: 'Jackson Labs',
    [TerritoryEnum.LOS_ANGELES]: 'Los Angeles',
    [TerritoryEnum.NEW_YORK]: 'New York',
    [TerritoryEnum.NORTHEAST]: 'Northeast',
    [TerritoryEnum.SAN_DIEGO]: 'San Diego',
    [TerritoryEnum.SOUTHEAST]: 'Southeast',
    [TerritoryEnum.TACONIC]: 'Taconic',
    [TerritoryEnum.WEST_COAST]: 'West Coast',
};

export const territories: TextValue[] = [
    { text: territoryText[TerritoryEnum.NONE], value: TerritoryEnum.NONE },
    { text: territoryText[TerritoryEnum.ASIA], value: TerritoryEnum.ASIA },
    { text: territoryText[TerritoryEnum.AUSTRALIA], value: TerritoryEnum.AUSTRALIA },
    { text: territoryText[TerritoryEnum.BOSTON], value: TerritoryEnum.BOSTON },
    { text: territoryText[TerritoryEnum.CHICAGO], value: TerritoryEnum.CHICAGO },
    { text: territoryText[TerritoryEnum.EUROPE], value: TerritoryEnum.EUROPE },
    { text: territoryText[TerritoryEnum.INDUSTRY_OTHER], value: TerritoryEnum.INDUSTRY_OTHER },
    { text: territoryText[TerritoryEnum.JACKSON_LABS], value: TerritoryEnum.JACKSON_LABS },
    { text: territoryText[TerritoryEnum.LOS_ANGELES], value: TerritoryEnum.LOS_ANGELES },
    { text: territoryText[TerritoryEnum.NEW_YORK], value: TerritoryEnum.NEW_YORK },
    { text: territoryText[TerritoryEnum.NORTHEAST], value: TerritoryEnum.NORTHEAST },
    { text: territoryText[TerritoryEnum.SAN_DIEGO], value: TerritoryEnum.SAN_DIEGO },
    { text: territoryText[TerritoryEnum.SOUTHEAST], value: TerritoryEnum.SOUTHEAST },
    { text: territoryText[TerritoryEnum.TACONIC], value: TerritoryEnum.TACONIC },
    { text: territoryText[TerritoryEnum.WEST_COAST], value: TerritoryEnum.WEST_COAST },
];
